import { defineMessages } from 'react-intl';

export const countryMessages = defineMessages({
  nationalTeam: {
    defaultMessage: '{country} National Football Team',
  },
} as const);
